import { updateItems } from '@/mocks/homeData';

export default function SectionUpdates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            最新更新
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时追踪最新剧集更新和新剧上架动态，追剧不迷路
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[25px] md:left-[31px] top-0 bottom-0 w-px bg-background-300/60"></div>

          <div className="space-y-0">
            {updateItems.map((item) => (
              <div key={item.id} className="relative flex gap-5 md:gap-6 pb-6 last:pb-0 pl-0">
                <div className="relative z-10 flex-shrink-0">
                  <div className={`w-[50px] md:w-[62px] py-2 rounded-lg text-center ${
                    item.category === '新剧入库'
                      ? 'bg-accent-100 text-accent-700'
                      : item.category === '大结局'
                      ? 'bg-primary-100 text-primary-700'
                      : item.category === '专题活动'
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    <span className="block text-xs md:text-sm font-bold font-heading leading-tight">
                      {item.date}
                    </span>
                  </div>
                </div>

                <div className="flex-1 min-w-0 pt-1">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className={`px-2 py-0.5 rounded text-[10px] md:text-xs font-medium whitespace-nowrap ${
                      item.category === '新剧入库'
                        ? 'bg-accent-100 text-accent-700'
                        : item.category === '大结局'
                        ? 'bg-primary-100 text-primary-700'
                        : item.category === '专题活动'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-background-200 text-foreground-600'
                    }`}>
                      {item.category}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}